import { useEffect, useState } from 'react'
import Shepherd from 'shepherd.js'
import 'shepherd.js/dist/css/shepherd.css'
import './style.css'
import { useDispatch } from 'react-redux'
import { setInsuranceDetailsTour, showNotificationMessage } from 'src/actions'
import { tourCompleted } from 'src/services/productTourServices'
import LoadingModal from 'src/components/common/LoadingModal'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import {
  INSURANCE_STEPS,
  INUSURANCE_STEP_DETAILS_2,
  INUSURANCE_STEP_DETAILS_3,
  INUSURANCE_STEP_DETAILS_5,
  NOTIFICATION_ERROR_MESSAGES,
} from 'src/utils/constants/TourConstants'

export default function InsuranceDetailsTour({
  userID,
  token,
  setTourCompleted,
}) {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      disableInteraction: true,
      exitOnEsc: false,
      defaultStepOptions: {
        titleClass: 'custom-title-class',
        textClass: 'custom-text-class',
        classes: 'shepherd-ele',
        attachTo: {
          element: '.RiskScoreTourStep1',
          on: 'bottom',
        },
        scrollTo: true,
      },
    })

    tour?.addStep({
      id: INSURANCE_STEPS?.STEP_2,
      text: INUSURANCE_STEP_DETAILS_2,
      attachTo: {
        element: '#policyDetailsCard',
        on: 'bottom',
      },
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      buttons: [
        {
          text: 'Next',
          classes: 'nextButton',
          action: tour.next,
        },
      ],
    })

    tour?.addStep({
      id: INSURANCE_STEPS?.STEP_3,
      text: INUSURANCE_STEP_DETAILS_3,
      attachTo: {
        element: '#policyCoverages',
        on: 'bottom',
      },
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      buttons: [
        {
          text: 'Back',
          classes: 'backButton',
          action: tour?.back,
        },

        {
          text: 'Next',
          classes: 'nextButton',
          action: tour?.next,
        },
      ],
    })

    tour?.addStep({
      id: INSURANCE_STEPS?.STEP_5,
      text: INUSURANCE_STEP_DETAILS_5,
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#allDocuments',
        on: 'bottom',
      },
      buttons: [
        {
          text: 'Back',
          classes: 'backButton',
          action: tour?.back,
        },
        {
          text: 'Done',
          classes: 'nextButton',
          action: () => {
            completeTheTour()
          },
        },
      ],
    })

    const completeTheTour = async () => {
      dispatch(setInsuranceDetailsTour(false))
      const userId = userID
      setLoading(true)
      const response = await tourCompleted(token, userId)
      try {
        setLoading(false)
        // success
        response?.success
          ? dispatch(
              showNotificationMessage({
                type: NOTIFICATION_TYPES?.SUCCESS,
                message: response?.message,
              })
            )
          : dispatch(
              showNotificationMessage({
                type: NOTIFICATION_TYPES?.ERROR,
                message: NOTIFICATION_ERROR_MESSAGES?.TRY_AGAIN_AFTER_SOMETIME,
              })
            )
      } catch (err) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message:
              NOTIFICATION_ERROR_MESSAGES?.ERROR_ENCOUNTERED_WHILE_FETCHING_POLICY_DETAILS,
          })
        )
      }
    }

    const handleTourComplete = () => {
      dispatch(setInsuranceDetailsTour(false))
      setTourCompleted(true)
    }

    tour?.on('complete', handleTourComplete)
    tour?.start()

    return () => {
      tour?.complete(() => {})
    }
  }, [userID, token, setTourCompleted, dispatch])

  return (
    <>
      <LoadingModal loading={loading} />
    </>
  )
}
